import { modelComposition } from 'trait/composition'

const descriptor = 'model::product'

export default modelComposition(descriptor)
